export default "__VITE_ASSET__DWLYZ1PI__"